<template>
    <div>
        <Form :label-width="140" class="margin-15 clearfix">
            <Col span="24">
                <FormItem label="总费用">
                    {{params.totalCost}}
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label="库内费用总额" >
                    {{params.operationCost + params.storageCost + params.valueAddedCost + params.adjustmentCost }}
                </FormItem>
            </Col>
            <Col span="24">
                <FormItem label="配送费总额">
                    {{params.deliveryCost}}
                </FormItem>
            </Col>
        </Form>
    </div>
</template>

<script>
export default {
    props:['params'],
    components: {
    },
    data(){
        return {
        }
    },
    async created() {
    },
    computed:{
    },
    methods:{
    }
}
</script>
